/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import featureNames from '~/shared/constants/featureFlags';
import {
  promoPriceHiddenPromoTypes,
  promoPriceNoStrikeThrough,
} from '~/shared/constants/products';
import useHasFeature from '~/shared/utils/useHasFeature';
import { ProductPrice } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.span``;

const PromoLabelFromCms = styled.span`
  ${({ theme }) => theme.promoMessage.overrideMarkupStylesFromCms};
`;

const HTMLTextWrapper = styled.span`
  margin-bottom: 8px;

  ${({ $promoMessageWrapperStyle }) => $promoMessageWrapperStyle};
  ${({ theme }) => theme.pdpStyles.promoMessage.copy};
`;

const PriceOffer = styled.span`
  ${({ theme }) => theme.pdpStyles.promoMessage.copy};
`;

const PriceOfferOr = styled.span`
  color: ${({ theme }) => theme.colors.priceOfferOr};
  font-size: 14px;
`;

function PromoPricingMessage({
  'data-autotag': dataAutotag,
  htmlText,
  pdpLabel,
  priceStyle,
  promoPriceStyle,
  product,
  ...rest
}) {
  const { promoCode, promoTypeId } = product?.promos || {};
  const hasPromo = Boolean(promoCode) && typeof promoCode === 'string';
  const showPromoPrice = hasPromo
    ? !promoPriceHiddenPromoTypes.has(promoTypeId)
    : undefined;
  const showStrikeThrough = !promoPriceNoStrikeThrough.has(promoTypeId);
  const displayRetailPrice = useHasFeature(featureNames.RETAILPRICETEST);

  if (!hasPromo) {
    return null;
  }

  return (
    <Wrapper {...rest} tabIndex={0}>
      <HTMLTextWrapper>
        <PromoLabelFromCms
          dangerouslySetInnerHTML={{ __html: `${htmlText}:` }}
        />
      </HTMLTextWrapper>{' '}
      <ProductPrice
        {...(hasPromo
          ? {
              promoPriceStyle,
              showPromoPrice,
              strikeRegularPrice: showStrikeThrough,
            }
          : {
              showPromoPrice: false,
            })}
        priceStyle={priceStyle}
        showVipPrice={!displayRetailPrice}
      />{' '}
      <PriceOfferOr>
        <FormattedMessage
          id="global_cta.outfit_credit_or"
          defaultMessage="or"
        />{' '}
      </PriceOfferOr>
      <PriceOffer>{pdpLabel}</PriceOffer>
    </Wrapper>
  );
}

PromoPricingMessage.propTypes = {
  'data-autotag': PropTypes.string,
  htmlText: PropTypes.string,
  pdpLabel: PropTypes.string,
  priceStyle: PropTypes.arrayOf(PropTypes.string),
  product: PropTypes.object,
  promoPriceStyle: PropTypes.any,
};

export default PromoPricingMessage;
